<template>
    <!-- Document Viewer !-->
    <document-viewer
        v-if="document"
        ref="documents" 
        :title="title" 
        :base-uri="url"
        :mime="mime"
        :allow-email="false"
        @hide="$emit('hide')"
    />
</template>

<script>
    import DocumentViewer from './FullScreenDocumentViewer'

    export default {
        components: {
            DocumentViewer
        },
        data() {
            return {
                document: null
            }
        },
        methods: {
            open(document) {
                this.document = document

                this.$nextTick(() => {
                    this.$refs.documents.open()
                })
            },
            hide() {
                this.$refs.documents.hide()
            }
        },
        computed: {
            title() {
                return this.document.title
            },
            url() {
                return this.document.view_url
            },
            mime() {
                return this.document.mime
            }
        }
    }
</script>